<div class="overLayDiv active"></div>
<div id="rightSideBar">
  <div class="rightSidePanel w-75pc active">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
          <h2>{{panelHeading}}</h2>
          <app-video-icon [VideoUrl]="videoLink | safeUrl">
          </app-video-icon>
      </div>
      <div>
        <button class="btn eod-btn-outline-warning mr-2" (click)="fnShowConfigureshowLoggingAlertPanel()">
          {{ "label_log" | translate }}
        </button>
        <button class="btn eod-btn-primary mr-2" [ngClass]="{'disabled':hasFormChanges == false }"
          (click)="fnUpdateReceiptTypeSettings()">
          {{'label_save' | translate }}
        </button>
        <button class="btn eod-btn-outline-warning" (click)="fnBacktoWizard()">
          {{backBtnText }}
        </button>
      </div>
    </header>
    <div class="clear"></div>
    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 margin-top-10 no-padding-right-left">
      <div class="block padding-bottom-20 padding-10">
        <div class="col-md-12 no-padding-right-left heightCalc-6">
          <app-grid [columns]="gridColumnDefs" [data]="gridData" [gridConfigItems]="gridConfigItems"
            (onCellClick)="fnOnGridCellClick($event)">
          </app-grid>
        </div>
      </div>
    </div>   
  </div>
</div>